// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__ICLVx","title":"styles_title__3GNxN","videoWrapper":"styles_videoWrapper__2LPB2","scrollToTop":"styles_scrollToTop__1CK_1"};